import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchAdvancedSurveyById = async ({ surveyId }) => {
  const token = localStorage.getItem("token");

  const URL = `${__API_URL__}/api/survey/advanced-surveys/${surveyId}/`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetAdvancedSurveyById = ({ surveyId, enabled }) => {
  return useQuery({
    queryKey: ["advanced_survey", surveyId],
    queryFn: () => fetchAdvancedSurveyById({ surveyId }),
    enabled: enabled && Boolean(surveyId),
  });
};

export default useGetAdvancedSurveyById;
